import { GuestBookingTripLog } from "@/redux/slices/guest/types";
import { transformBookingTripLog } from "../booking/helpers";
import { ClientBookingData } from "../clientBooking/types";
import { RawGuestBookingData, RawGuestBookingTripLog } from "./types";

export const transformGuestBookingTripLog: (tripLog: RawGuestBookingTripLog) => GuestBookingTripLog = transformBookingTripLog;

/**
 * Normalise the guest job-data (root entity, `vehicle_categories`, extra `cost`) onto the shared
 * `ClientBookingData` contract the wizard already consumes (`vehicles`, extra `amount`). Once mapped,
 * VehicleTransferPanel keys transfer/vehicle/extra selections on the same numeric ids it uses for the
 * authed client data, so the panel works unchanged when fed guest data via useBookingData.
 */
export const transformGuestBookingData = (raw: RawGuestBookingData): ClientBookingData => ({
  transfer_types: (raw?.transfer_types ?? []).map((t) => ({
    id: t.id,
    // Preserved for buildGuestQuoteBody — the guest-quote endpoint keys transfer_type on the uuid.
    uuid: t.uuid,
    label: t.label,
    // The entity names the job-rate `rate` / `is_special_event`; the ClientBookingData contract reads
    // them as `type` / `special_event` (job_rate + the hourly/daily duration gate depend on `type`).
    // Legacy `type` / `special_event` kept as a defensive fallback.
    type: t.rate ?? t.type ?? "",
    special_event: t.is_special_event ?? t.special_event ?? false,
    vehicle_exclusions: t.vehicle_exclusions ?? [],
  })),
  vehicles: (raw?.vehicle_categories ?? []).map((v) => ({
    vehicle_id: v.vehicle_id,
    uuid: v.uuid,
    name: v.name,
    max_passengers: v.max_passengers,
    max_bags: v.max_bags,
  })),
  extras: (raw?.extras ?? []).map((e) => ({
    extra_id: e.extra_id,
    name: e.name,
    amount: e.cost,
  })),
  hourly_rates: raw?.hourly_rates ?? [],
  daily_rates: raw?.daily_rates ?? [],
  // Sourced from job/data so the guest flow needs no separate /v1/provider call.
  max_waypoints: raw?.max_waypoints,
});
